{
  "name": "tempus",
  "version": "1.0.0-dev.18",
  "description": "one rAF to rule them all",
  "type": "module",
  "sideEffects": false,
  "unpkg": "./dist/tempus.mjs",
  "main": "./dist/tempus.mjs",
  "module": "./dist/tempus.mjs",
  "types": "./dist/tempus.d.ts",
  "exports": {
    ".": {
      "types": "./dist/tempus.d.ts",
      "default": "./dist/tempus.mjs"
    },
    "./react": {
      "types": "./dist/tempus-react.d.ts",
      "default": "./dist/tempus-react.mjs"
    },
    "./profiler": {
      "types": "./dist/tempus-profiler.d.ts",
      "default": "./dist/tempus-profiler.mjs"
    },
    "./dist/*": "./dist/*"
  },
  "scripts": {
    "build": "pnpm build:core && pnpm build:all",
    "build:core": "tsup --config tsup.core.ts",
    "build:all": "tsup",
    "dev": "pnpm run -w --parallel /^dev:.*/",
    "dev:build": "tsup --watch",
    "dev:playground": "pnpm --filter playground dev",
    "readme": "node ./scripts/update-readme.js",
    "version:dev": "npm version prerelease --preid dev --force --no-git-tag-version",
    "version:patch": "npm version patch --force --no-git-tag-version",
    "version:minor": "npm version minor --force --no-git-tag-version",
    "version:major": "npm version major --force --no-git-tag-version",
    "postversion": "pnpm build && pnpm readme",
    "publish:main": "npm publish",
    "publish:dev": "npm publish --tag dev"
  },
  "files": [
    "dist"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/darkroomengineering/tempus.git"
  },
  "keywords": [
    "raf",
    "ticker",
    "framerate",
    "fps"
  ],
  "author": "darkroom.engineering",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/darkroomengineering/tempus/issues"
  },
  "homepage": "https://github.com/darkroomengineering/tempus",
  "funding": {
    "type": "github",
    "url": "https://github.com/sponsors/darkroomengineering"
  },
  "devDependencies": {
    "@biomejs/biome": "1.9.4",
    "tsup": "^8.3.6",
    "typescript": "^5.7.3",
    "lottie-web": "^5.13.0",
    "motion": "^12.40.0"
  },
  "peerDependencies": {
    "react": ">=17.0.0"
  },
  "peerDependenciesMeta": {
    "react": {
      "optional": true
    }
  }
}
